import React, { createContext, forwardRef } from 'react';
export var EzProviderContext = createContext(null);
var EzProvider = forwardRef(function EzProvider(_ref, ref) {
  var theme = _ref.theme,
    children = _ref.children;
  return React.createElement(EzProviderContext.Provider, {
    value: theme === null || theme === void 0 ? void 0 : theme.toString()
  }, React.createElement("div", {
    className: theme === null || theme === void 0 ? void 0 : theme.toString(),
    ref: ref
  }, children));
});
export default EzProvider;